import { normalizePhoneNumber } from "./ConsumerInfoValidator";
var isEdited = function (editedFields, field) {
    return editedFields.indexOf(field) >= 0;
};
var normalizeText = function (value) { return (value || "").trim(); };
var resolveText = function (initialValue, updatedValue, edited) {
    if (edited) {
        return normalizeText(updatedValue);
    }
    var normalizedUpdate = normalizeText(updatedValue);
    return normalizedUpdate || normalizeText(initialValue);
};
var ConsumerInfoResolver = /** @class */ (function () {
    function ConsumerInfoResolver() {
    }
    ConsumerInfoResolver.resolve = function (initialConsumer, update) {
        var _a, _b;
        var editedFields = (update === null || update === void 0 ? void 0 : update.editedFields) || [];
        var updatedValue = update === null || update === void 0 ? void 0 : update.value;
        var mobileNumberEdited = isEdited(editedFields, "mobileNumber");
        var resolvedMobileNumber = normalizePhoneNumber({
            countryCode: resolveText((_a = initialConsumer === null || initialConsumer === void 0 ? void 0 : initialConsumer.mobileNumber) === null || _a === void 0 ? void 0 : _a.countryCode, updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.mobileNumber.countryCode, mobileNumberEdited),
            phoneNumber: resolveText((_b = initialConsumer === null || initialConsumer === void 0 ? void 0 : initialConsumer.mobileNumber) === null || _b === void 0 ? void 0 : _b.phoneNumber, updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.mobileNumber.phoneNumber, mobileNumberEdited),
        });
        var countryCode = resolveText(initialConsumer === null || initialConsumer === void 0 ? void 0 : initialConsumer.countryCode, updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.countryCode, isEdited(editedFields, "countryCode")).toUpperCase();
        return {
            firstName: resolveText(initialConsumer === null || initialConsumer === void 0 ? void 0 : initialConsumer.firstName, updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.firstName, isEdited(editedFields, "firstName")),
            lastName: resolveText(initialConsumer === null || initialConsumer === void 0 ? void 0 : initialConsumer.lastName, updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.lastName, isEdited(editedFields, "lastName")),
            emailAddress: resolveText(initialConsumer === null || initialConsumer === void 0 ? void 0 : initialConsumer.emailAddress, updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.emailAddress, isEdited(editedFields, "emailAddress")),
            mobileNumber: resolvedMobileNumber,
            countryCode: countryCode || undefined,
            nationalIdentifier: normalizeText(initialConsumer === null || initialConsumer === void 0 ? void 0 : initialConsumer.nationalIdentifier) || undefined,
            consumerIdentity: (initialConsumer === null || initialConsumer === void 0 ? void 0 : initialConsumer.consumerIdentity)
                ? {
                    identityProvider: initialConsumer.consumerIdentity.identityProvider,
                    identityType: initialConsumer.consumerIdentity.identityType,
                    type: initialConsumer.consumerIdentity.type,
                    identityValue: initialConsumer.consumerIdentity.identityValue,
                }
                : undefined,
        };
    };
    return ConsumerInfoResolver;
}());
export { ConsumerInfoResolver };
